import React from "react";
import { Form, Col, Row } from "react-bootstrap";
import Select from "react-select";
import { FormHelper, ConfiguracionEmailHelper } from "utils";
import { EmailInput, SvgComponent } from "components";
import RadioGroup from "components/RadioGroup/RadioGroup";
import EditSection from "components/PantallasEdit/EditSection/EditSection";
import SectionRow from "components/PantallasEdit/SectionRow/SectionRow";
import InputContainer from "components/PantallasEdit/InputContainer/InputContainer";
import VincularCuentaGoogle from "components/Email/VincularCuentaGoogle";
import VincularCuentaMicrosoft from "components/Email/VincularCuentaMicrosoft";
import VincularCuentaSendGrid from "components/Email/VincularEmailSendGrid";
import ToolTip from "components/ToolTip/ToolTip";

export default function ServidorCorreoTab({
  compania,
  setCompania,
  setCheckedProp,
  configuracionEmail,
  setConfiguracionEmail,
  tipoActual,
  setTipoActual,
  setDefaultTipo,
  showLoading,
  hideLoading,
  usuario,
}) {
  function ToggleRow({ name, label, tooltip, checked, onChange }) {
    configuracionEmail.Tipo = configuracionEmail.Tipo ? configuracionEmail.Tipo : ConfiguracionEmailHelper.TIPO_SERVIDOR_CORREO.SMTP

    return (
      <div
        className="d-flex align-items-center justify-content-between py-2"
        style={{ marginBottom: "40px" }}
      >
        <div className="d-flex align-items-center">
          <span>{label}</span>
          <ToolTip message={tooltip} placement="top">
            <span
              className="ml-2"
              style={{ display: "inline-flex", alignItems: "center", cursor: "pointer" }}
            >
              <SvgComponent iconName="info" fill="#1E88E5" />
            </span>
          </ToolTip>
        </div>
        <Form.Check
          type="switch"
          id={`sw-${name}`}
          name={name}
          checked={!!checked}
          onChange={onChange}
          label=""
        />
      </div>
    );
  }

  return (
    <div className="px-3 pb-4">
      <EditSection title="Servidor de Correos" style={{}}>
        <SectionRow>
          <Row className="mx-0 mt-3">
            <Col xs={12} md={10} lg={9} className="px-0">
              <ToggleRow
                key="UsaServidorCorreo"
                name="UsaServidorCorreo"
                label="Configurar Servidor Correo Electrónico"
                tooltip="Permite configurar un Servidor para envío de correos."
                checked={compania.UsaServidorCorreo}
                onChange={setCheckedProp}
              />
            </Col>
          </Row>
        </SectionRow>

        {compania.UsaServidorCorreo && (
          <>
            <SectionRow>
              <InputContainer stacked label="Tipo">
                <RadioGroup
                  options={ConfiguracionEmailHelper.TIPO_SERVIDOR_CORREO_DDL}
                  selectedOption={configuracionEmail.Tipo}
                  onChange={(e) => {
                    setConfiguracionEmail({
                      ...configuracionEmail,
                      Tipo: e.target.value,
                    });
                  }}
                />
              </InputContainer>
            </SectionRow>


            {configuracionEmail.Tipo === ConfiguracionEmailHelper.TIPO_SERVIDOR_CORREO.SMTP && (
              <>
                <SectionRow>
                  <InputContainer label="Servidor SMTP" labelSize={3}>
                    <Form.Control
                      name="ServidorSMTP"
                      type="text"
                      placeholder="Servidor SMTP"
                      onChange={(e) => FormHelper.handleChange(e, setCompania)}
                      value={compania.ServidorSMTP}
                    />
                  </InputContainer>

                  <InputContainer label="Puerto" labelSize={3}>
                    <Form.Control
                      name="Puerto"
                      type="number"
                      placeholder="Puerto"
                      onChange={(e) => FormHelper.handleChange(e, setCompania)}
                      value={compania.Puerto}
                    />
                  </InputContainer>
                </SectionRow>

                <SectionRow>
                  <InputContainer label="Usar Autenticación" labelSize={4}>
                    <Form.Check
                      type="switch"
                      id="ckUsarAutenticacion"
                      name="UsarAutenticacion"
                      checked={compania.UsarAutenticacion}
                      onChange={setCheckedProp}
                      label=""
                    />
                  </InputContainer>

                  <InputContainer label="Usar TLS/SSL" labelSize={4}>
                    <Form.Check
                      type="switch"
                      id="ckUsarTLSSSL"
                      name="UsarTLSSSL"
                      checked={compania.UsarTLSSSL}
                      onChange={setCheckedProp}
                      label=""
                    />
                  </InputContainer>
                </SectionRow>

                <SectionRow>
                  <InputContainer label="Usuario" labelSize={3}>
                    <Form.Control
                      name="Usuario"
                      type="text"
                      placeholder="Usuario"
                      onChange={(e) => FormHelper.handleChange(e, setCompania)}
                      value={compania.Usuario}
                    />
                  </InputContainer>

                  <InputContainer label="Contraseña" labelSize={3}>
                    <Form.Control
                      name="Contraseña"
                      type="password"
                      placeholder="Contraseña"
                      onChange={(e) => FormHelper.handleChange(e, setCompania)}
                      value={compania.Contraseña}
                    />
                  </InputContainer>
                </SectionRow>

                <SectionRow>
                  <InputContainer label="Correo Emisor" labelSize={3}>
                    <EmailInput
                      key={"correoEmisor" + compania.Id}
                      inputValue={compania.CorreoEmisor}
                      noMultiple={true}
                      placeholder="Correo Emisor"
                      parentCallback={(e) => {
                        setCompania({ ...compania, CorreoEmisor: e });
                      }}
                    />
                  </InputContainer>

                  <InputContainer label="Nombre Emisor" labelSize={3}>
                    <Form.Control
                      name="NombreEmisor"
                      type="text"
                      placeholder="Nombre Emisor"
                      onChange={(e) => FormHelper.handleChange(e, setCompania)}
                      value={compania.NombreEmisor}
                    />
                  </InputContainer>
                </SectionRow>
              </>
            )}

            {configuracionEmail.Tipo === ConfiguracionEmailHelper.TIPO_SERVIDOR_CORREO.GMAIL && usuario.CompaniaId && (
              <VincularCuentaGoogle
                showLoading={showLoading}
                hideLoading={hideLoading}
                configuracionEmail={configuracionEmail || {}}
                setConfiguracionEmail={setConfiguracionEmail}
                setDefaultTipo={setDefaultTipo}
                tipoActual={tipoActual}
                setTipoActual={setTipoActual}
                fuente={ConfiguracionEmailHelper.FUENTE_ENTIDAD.COMPANIA}
                referencia={usuario.CompaniaId}
              ></VincularCuentaGoogle>
            )}

            {configuracionEmail.Tipo === ConfiguracionEmailHelper.TIPO_SERVIDOR_CORREO.OUTLOOK && (
              <VincularCuentaMicrosoft
                showLoading={showLoading}
                hideLoading={hideLoading}
                configuracionEmail={configuracionEmail || {}}
                setConfiguracionEmail={setConfiguracionEmail}
                setDefaultTipo={setDefaultTipo}
                tipoActual={tipoActual}
                setTipoActual={setTipoActual}
              ></VincularCuentaMicrosoft>
            )}

            {configuracionEmail.Tipo === ConfiguracionEmailHelper.TIPO_SERVIDOR_CORREO.SENDGRID && (
              <VincularCuentaSendGrid
                showLoading={showLoading}
                hideLoading={hideLoading}
                configuracionEmail={configuracionEmail || {}}
                setConfiguracionEmail={setConfiguracionEmail}
                setDefaultTipo={setDefaultTipo}
                tipoActual={tipoActual}
                setTipoActual={setTipoActual}
              />
            )}
          </>
        )}
      </EditSection>
    </div>
  );
}
